module.exports = __webpack_public_path__ + "static/media/icon-plans.1c721c4a.svg";